import React from "react";

const MultipleChoice = ({ question, options, value, onChange }) => {
  // Ensure selectedValues is always an array
  const selectedValues = Array.isArray(value) ? value : [];

  const handleCheckboxChange = (option) => {
    let newValues;
    if (selectedValues.includes(option)) {
      newValues = selectedValues.filter((item) => item !== option);
    } else {
      newValues = [...selectedValues, option];
    }
    onChange(newValues);
  };

  return (
    <div className="multiple-choice-question">
      <h4 className="question-text mb-4">{question}</h4>
      <div className="options-list">
        {options.map((option, index) => (
          <div key={index} className="form-check mb-3 p-3 border rounded">
            <input
              className="form-check-input"
              type="checkbox"
              id={`checkbox-${index}`}
              value={option}
              checked={selectedValues.includes(option)}
              onChange={() => handleCheckboxChange(option)}
            />
            <label
              className="form-check-label w-100"
              htmlFor={`checkbox-${index}`}
              style={{ cursor: "pointer", paddingLeft: "10px" }}
            >
              {option}
            </label>
          </div>
        ))}
      </div>
      {selectedValues.length > 0 && (
        <div className="mt-3">
          <small className="text-muted">
            Selected: {selectedValues.join(", ")}
          </small>
        </div>
      )}
    </div>
  );
};

export default MultipleChoice;
